export const ErrorMessage = ({ text }: { text: string }) => (
  <p className="subHeading text-error py-1">{text}</p>
);
